'use client';

import { useCallback, useEffect, useState } from 'react';

import type { MermaidDiagram } from '@/data/blog/types';

export const useMermaidFullscreen = () => {
  const [activeDiagram, setActiveDiagram] = useState<MermaidDiagram | null>(null);

  useEffect(() => {
    if (!activeDiagram) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setActiveDiagram(null);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [activeDiagram]);

  const open = useCallback((diagram: MermaidDiagram) => {
    if ((diagram.kind ?? 'mermaid') === 'video') return;
    setActiveDiagram(diagram);
  }, []);

  const close = useCallback(() => {
    setActiveDiagram(null);
  }, []);

  return { activeDiagram, open, close };
};

export type UseMermaidFullscreenReturn = ReturnType<typeof useMermaidFullscreen>;
